import {
  safeGetLocalStorageItem,
  safeSetLocalStorageItem,
} from '@mc/browser-storage'
import {
  canSaveUserData,
  initUserData,
  SavedUserData,
  SaveUserDataProps,
  USER_DATA_UPDATED_EVENT,
} from './utils'

export const saveUserData = ({
  key,
  id,
  actionType,
  eventName,
}: SaveUserDataProps) => {
  if (!canSaveUserData()) return
  if (!key || !id || !actionType || !eventName) return

  const data: SavedUserData = JSON.parse(safeGetLocalStorageItem(key) || '{}')

  const updatedData = initUserData({
    key,
    data,
    id,
    actionType,
    eventName,
  })

  const eventsData = updatedData[id][actionType]
  eventsData.overallCount += 1
  eventsData[eventName].lastUpdated = new Date(Date.now()).toISOString()
  eventsData[eventName].count += 1

  safeSetLocalStorageItem(key, JSON.stringify(updatedData))
  window?.dispatchEvent(new Event(USER_DATA_UPDATED_EVENT))
}
